import React from 'react';
import { Link } from 'react-router-dom';
import { Button, FormGroup, Input, Col, Row, Container, Table } from 'reactstrap';
import api from '../../api';
import './index.css';

export default class Segment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            segment: this.props.segment || null,
        };
    }
    deleteSegment() {
        const confirmation = window.confirm('Are you sure to delete this segment? This action cannot be undone');
        if (!confirmation) return;
        const { segment } = this.state;
        api.fetchAPI({
            method: 'delete',
            uri: `segments`,
            body: segment,
            success: (response) => {
                this.setState({
                    segment: null,
                });
                this.setState({ isLoading: false });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    render() {
        const { segment } = this.state;
        if (!segment) return null;
        return (
            <div className="segment-container">
                <h5>{segment.name}</h5>
                <p>{segment.description}</p>
                <Button color="primary" size="sm" tag={Link} to ={`/segment/${segment.id}`}>Detail</Button>
                <Button color="info" size="sm" tag={Link} to ={`/segment/${segment.id}/edit`}>Edit</Button>
                <Button color="danger" size="sm" onClick={()=> this.deleteSegment()}>Delete</Button>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Segment/index.js